import L from "leaflet";

export function createMap(mapEl, options = {}) {
  const map = L.map(mapEl, {
    zoomControl: true,
    preferCanvas: true,
    scrollWheelZoom: false,
  }).setView([39.8283, -98.5795], 4);

  const baseMaps = {};
  if (options.thunderforestUrl) {
    baseMaps.Terrain = L.tileLayer(options.thunderforestUrl, {
      maxZoom: 24,
      maxNativeZoom: 22,
      crossOrigin: "anonymous",
      attribution: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> | Map style: &copy; <a href="https://www.thunderforest.com/">Thunderforest</a>',
    });
  }

  Object.assign(baseMaps, {
    Topo: L.tileLayer(
      "https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
      {
        maxZoom: 20,
        crossOrigin: "anonymous",
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, CyclOSM',
      }
    ),
    "OSM Standard": L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        maxZoom: 19,
        crossOrigin: "anonymous",
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }
    ),
    "Satellite (ESRI)": L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      {
        maxZoom: 19,
        attribution: "Tiles &copy; Esri",
      }
    ),
    "Topo (ESRI)": L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
      {
        maxZoom: 19,
        attribution: "Tiles &copy; Esri",
      }
    ),
  });

  (baseMaps.Terrain || baseMaps.Topo).addTo(map);
  L.control
    .layers(baseMaps, null, { collapsed: false, position: "topright" })
    .addTo(map);
  L.control.scale({ metric: true, imperial: true, position: "bottomleft" }).addTo(map);

  setTimeout(() => map.invalidateSize(), 50);
  window.addEventListener("resize", () => map.invalidateSize());

  return map;
}

export function fitBoundsAndWait(map, bounds, options) {
  return new Promise((resolve) => {
    let finished = false;
    let timeout = null;
    const finish = () => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      map.off("moveend", finish);
      resolve();
    };

    map.on("moveend", finish);
    map.fitBounds(bounds, options);
    timeout = setTimeout(finish, 500);
  });
}
